// extracted by mini-css-extract-plugin
module.exports = {"contain":"SxsB5RV4","title":"cvglp24g","arrowRight":"qG1mwnVP"};